<template>
  <div>
    <div class="text-center">
      <v-dialog v-model="dialogBookingTaken" width="500">
        <v-alert prominent type="error">
          <v-row align="center">
            <v-col class="grow">
              <b>Sorry!</b> you've just missed that time slot. Please choose
              another.
            </v-col>
            <v-col class="shrink">
              <v-icon @click="dialogBookingTaken = !dialogBookingTaken"
                >cancel</v-icon
              >
            </v-col>
          </v-row>
        </v-alert>
      </v-dialog>
    </div>
    <v-alert
      class="mt-3"
      border="bottom"
      color="deep-purple"
      dark
      v-if="this.message !== false"
      >{{ this.message }}</v-alert
    >

    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          v-if="this.steps.fluQuestions.active"
          :complete="step > this.steps.fluQuestions.step"
          :step="this.steps.fluQuestions.step"
          >{{ this.steps.fluQuestions.title }}</v-stepper-step
        >
        <v-divider v-if="this.steps.fluQuestions.active"></v-divider>

        <v-stepper-step
          v-if="this.steps.covidQuestions.active"
          :complete="step > this.steps.covidQuestions.step"
          :step="this.steps.covidQuestions.step"
          >{{ this.steps.covidQuestions.title }}</v-stepper-step
        >
        <v-divider v-if="this.steps.covidQuestions.active"></v-divider>

        <v-stepper-step
          v-if="this.steps.premilinary.active"
          :complete="step > this.steps.premilinary.step"
          :step="this.steps.premilinary.step"
          >{{ this.steps.premilinary.title }}</v-stepper-step
        >
        <v-divider v-if="this.steps.premilinary.active"></v-divider>

        <v-stepper-step
          v-if="this.steps.slots.active"
          :complete="step > this.steps.slots.step"
          :step="this.steps.slots.step"
          >{{ this.steps.slots.title }}</v-stepper-step
        >
        <v-divider v-if="this.steps.slots.active"></v-divider>

        <v-stepper-step
          v-if="this.steps.contactdetails.active"
          :complete="step > this.steps.contactdetails.step"
          :step="this.steps.contactdetails.step"
          >{{ this.steps.contactdetails.title }}</v-stepper-step
        >
        <v-divider v-if="this.steps.contactdetails.active"></v-divider>

        <v-stepper-step
          vi-if="this.steps.preassessment.active"
          :complete="step > this.steps.preassessment.step"
          :step="this.steps.preassessment.step"
          >{{ this.steps.preassessment.title }}</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-if="this.steps.fluQuestions.active"
          :step="this.steps.fluQuestions.step"
        >
          <div class="person-form">
            <v-form ref="fluForm">
              <v-alert :value="flueVaccineMessage" type="error">{{
                fluVaccineQuestions.message
              }}</v-alert>
              <v-col cols="12" md="12">
                <p v-for="flu in fluVaccineQuestions.questions" :key="flu.id">
                  {{ flu.question }}
                  <v-radio-group
                    :mandatory="false"
                    v-model="customField[flu.id]"
                    :rules="[rules.required]"
                    row
                  >
                    <v-radio
                      v-for="option in flu.options"
                      :key="option.id"
                      :label="option.option"
                      :value="option.option"
                    ></v-radio>
                  </v-radio-group>
                </p>
              </v-col>
            </v-form>
            <v-col cols="12" md="12">
              <v-row>
                <v-col style="text-align: right">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="float-right hp--btn"
                    @click="submitFluVaccineQuestions"
                    >Continue</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-stepper-content>

        <CovidQuestions
          v-if="this.steps.covidQuestions.active"
          :step="this.steps.covidQuestions.step"
          :covidQuestions="covidQuestions"
          @toParent="questionHandler"
        />

        <v-stepper-content
          v-if="this.steps.premilinary.active"
          :step="this.steps.premilinary.step"
        >
          <div class="person-form">
            <v-form ref="preliminaryForm">
              <v-alert
                v-for="message in preliminaryQuestionMessage"
                :key="message.length"
                :value="preliminaryQuestionShowMessage"
                type="error"
                dense
                >{{ message }}</v-alert
              >
              <div
                v-for="collectUserData in this.collectUserDatas"
                :key="collectUserData.id"
              >
                <v-row v-if="collectUserData.questionType === 'PREQUESTION'">
                  <v-col cols="12" md="12">
                    <v-icon
                      v-if="collectUserData.fieldType !== 'checkbox'"
                      class="float-left py-4 pr-2"
                      color="primary"
                      >mdi-pencil</v-icon
                    >
                    <v-text-field
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'text'"
                      persistent-hint
                      class="hint"
                      :hint="collectUserData.hint"
                      filled
                      :rules="collectUserData.validation"
                      :label="collectUserData.label"
                      required
                    ></v-text-field>

                    <v-select
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'select'"
                      persistent-hint
                      class="hint"
                      :hint="collectUserData.hint"
                      filled
                      :rules="collectUserData.validation"
                      :label="collectUserData.label"
                      :items="collectUserData.options"
                      required
                    ></v-select>

                    <v-checkbox
                      class="ml-7 hint"
                      persistent-hint
                      :hint="collectUserData.hint"
                      :rules="collectUserData.validation"
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'checkbox'"
                      :label="collectUserData.label"
                      value="true"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col style="text-align: right">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    class="float-right hp--btn"
                    @click="submitPreliminaryQuestions"
                    >Continue</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-stepper-content>
        <v-stepper-content
          v-if="this.steps.slots.active"
          :step="this.steps.slots.step"
        >
          <v-alert
            color="indigo"
            dark
            dense
            v-if="this.description !== false"
            >{{ this.description }}</v-alert
          >
          <v-row no-gutters>
            <v-col cols="8">
              <v-row v-if="showLocation" class="ma-0 pa-0">
                <v-col cols="12" sm="3" class="ma-0 pa-0">
                  <v-select
                    v-on:change="selectLocation"
                    v-model="location"
                    :items="locations"
                    label="Location"
                    hint="Choose a location"
                    :menu-props="{ bottom: true, offsetY: true }"
                    persistent-hint
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <v-row v-if="showDate" class="ma-0 pa-0">
                <v-col cols="12" sm="3" class="ma-0 pa-0">
                  <v-select
                    v-on:change="selectDate"
                    v-model="date"
                    :items="dates"
                    label="Click here to select a date"
                    :menu-props="{
                      bottom: true,
                      offsetY: true,
                      maxHeight: 604
                    }"
                    persistent-hint
                    required
                  ></v-select>
                </v-col>
              </v-row>

              <h1 v-if="room">
                {{ room }} - {{ eventLocation }} - {{ dateFormatted }}
              </h1>
              <div class="slot-list">
                <template v-for="slot in slots">
                  <v-radio
                    v-if="!slot.booked"
                    v-on:change="selectTimeSlot(slot.id)"
                    v-bind:key="slot.id"
                    :label="slot.time"
                    :value="slot.id"
                  ></v-radio>
                  <p v-bind:key="slot.time" style="color: red">
                    <s
                      v-if="slot.booked"
                      title="This slot is no longer available"
                      >{{ slot.time }}</s
                    >
                  </p>
                </template>
              </div>
            </v-col>
            <v-col cols="4">
              <v-img :src="logo"></v-img>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-content
          v-if="this.steps.contactdetails.active"
          :step="this.steps.contactdetails.step"
        >
          <div class="person-form">
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-icon
                    class="float-left py-4 pr-2 d-none d-sm-flex"
                    color="primary"
                    >person</v-icon
                  >
                  <v-text-field
                    filled
                    v-model="firstname"
                    label="First name"
                    :rules="[v => !!v || 'Item is required']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    filled
                    v-model="lastname"
                    :rules="[v => !!v || 'Item is required']"
                    label="Last name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="4" md="4">
                  <v-icon
                    class="float-left py-4 pr-2 d-none d-sm-flex"
                    color="primary"
                    >email</v-icon
                  >
                  <v-text-field
                    filled
                    v-model="email"
                    :rules="emailRules"
                    label="Email"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="4" md="4">
                  <v-icon
                    class="float-left py-4 pr-2 d-none d-sm-flex"
                    color="primary"
                    >email</v-icon
                  >
                  <v-text-field
                    filled
                    v-model="confirmEmail"
                    :rules="confirmEmailRules"
                    label="Confirm email"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="4" md="4">
                  <v-icon
                    class="float-left py-4 pr-2 d-none d-sm-flex"
                    color="primary"
                    >settings_cell</v-icon
                  >
                  <v-text-field
                    class="hint"
                    filled
                    v-model="mobile"
                    @keypress="isNumber($event)"
                    label="Mobile number"
                    hint="for SMS confirmation"
                    v-mask="'##############'"
                    persistent-hint
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" class>
                  <v-icon
                    class="float-left py-4 pr-2 d-none d-sm-flex"
                    color="primary"
                    >mdi-calendar</v-icon
                  >
                  <v-select
                    filled
                    v-model="dobDay"
                    :rules="requiredRules"
                    label="Date of birth (day)"
                    hint="01 - 31"
                    :persistent-hint="true"
                    :items="days"
                    required
                    :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                    filled
                    v-model="dobMonth"
                    :rules="requiredRules"
                    label="Date of birth (month)"
                    hint="January - December"
                    :persistent-hint="true"
                    :items="months"
                    required
                    :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                    filled
                    v-model="dobYear"
                    :rules="requiredRules"
                    label="Date of birth (year)"
                    hint="Date of birth (year)"
                    :persistent-hint="true"
                    :items="rangeOfYears"
                    required
                    :menu-props="{ maxHeight: '800', top: true, offsetY: true }"
                  ></v-select>
                </v-col>
              </v-row>

              <div
                v-for="collectUserData in this.collectUserDatas"
                :key="collectUserData.id"
              >
                <v-row v-if="collectUserData.questionType !== 'PREQUESTION'">
                  <v-col cols="12" md="12">
                    <v-icon
                      class="float-left py-4 pr-2 d-none d-sm-flex"
                      v-if="collectUserData.fieldType !== 'checkbox'"
                      color="primary"
                      >mdi-pencil</v-icon
                    >
                    <v-text-field
                      class="hint"
                      persistent-hint
                      :hint="collectUserData.hint"
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'text'"
                      filled
                      :rules="collectUserData.validation"
                      :label="collectUserData.label"
                      required
                    ></v-text-field>
                    <v-select
                      class="hint"
                      persistent-hint
                      :hint="collectUserData.hint"
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'select'"
                      filled
                      :rules="collectUserData.validation"
                      :label="collectUserData.label"
                      :items="collectUserData.options"
                      required
                    ></v-select>
                    <v-checkbox
                      class="hint"
                      persistent-hint
                      :rules="collectUserData.validation"
                      :hint="collectUserData.hint"
                      v-model="customField[collectUserData.fieldName]"
                      v-if="collectUserData.fieldType === 'checkbox'"
                      :label="collectUserData.label"
                      value="true"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </div>

              <v-row>
                <v-col cols="7" sm="7">
                  <v-checkbox
                    v-model="termsAgree"
                    :error-messages="termsAgreeErrors"
                    :rules="[v => !!v || 'Please agree to our terms']"
                  >
                    <template v-slot:label>
                      <div>
                        I have read and agree to our Health Assessment
                        <a
                          target="_blank"
                          href="/downloads/privacy-policy.pdf"
                          @click.stop
                        >
                          privacy policy
                        </a>
                        and our
                        <a
                          target="_blank"
                          href="/downloads/terms-of-usage.pdf"
                          @click.stop
                        >
                          terms of use
                        </a>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="5" sm="5" style="text-align: right">
                  <v-btn
                    color="primary"
                    :right="true"
                    @click="submitPersonDetails"
                    :loading="submitPersonLoader"
                    class="hp--btn"
                    >Continue</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-stepper-content>

        <v-stepper-content
          v-if="this.steps.preassessment.active"
          :step="this.steps.preassessment.step"
        >

          <v-layout text-center wrap>
            <v-flex xs12>
              <v-img
                :src="require('../assets/green-tick.png')"
                class="my-3"
                contain
                height="120"
              ></v-img>
            </v-flex>

            <v-flex xs12>
              <h1 class="display-1">Your appointment has been booked</h1>
            </v-flex>

            <v-flex xs12 color="grey mt-2 lighten-2"
              >You will receive email and SMS confirmation plus a calendar
              invite with full details.</v-flex
            >

            <v-flex>

              <v-row class="mb-0 mt-3" style="background-color: #e6e1e9">
                <v-col cols="5">
                  <div><strong>What next?</strong></div>
                  <div class="pa-3">
                    Click start to answer some pre-assessment questions to
                    maximise our time with you. It should only take 3-5
                    minutes.
                  </div>
                </v-col>
                <v-col cols="2" style="display: flex; justify-content: center; align-items: center;">
                  <a v-bind:href="'https://preassessment.healthyevents.co.uk/' + preAssessmentId" target="_blank" class="hp--btn v-btn v-btn--has-bg theme--light v-size--large primary">
                    <span class="v-btn__content">Continue</span>
                  </a>
                </v-col>
                <v-col cols="5">
                  <div><strong>Pressed for time?</strong></div>
                  <div class="pa-3">
                    Don’t worry,
                    <a
                        href="#"
                        style="color: #0fdb94"
                        @click="sendPreAssessmentLink()"
                        @click.stop
                    >click here</a>
                    and we'll send you a link so you can complete the
                    pre-assessment questions when it's more convenient.
                  </div>
                </v-col>
              </v-row>
            </v-flex>

          </v-layout>
        </v-stepper-content>
        <v-stepper-content step="4"></v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { API } from "aws-amplify";
import { onUpdateEventSlot } from "./../graphql/subscriptions";
import moment from "moment";
import { Booking } from "../classes/Booking";
import * as PreQuestions from "../classes/PreQuestions";
import { PreAssessment } from "../classes/PreAssessment";
import JQuery from "jquery";
import CovidQuestions from "../components/CovidQuestions";
import { s3helper } from "../classes/s3helper";
import { required, email, sameAs } from "vuelidate/lib/validators";
import _ from "lodash";

export default {
  props: {
    eventData: Array
  },
  components: {
    CovidQuestions
  },
  data() {
    return {
      dialogBookingTaken: false,
      submitPersonLoader: false,
      logo: null,
      event: null,
      collectUserDatas: [],
      fluVaccineQuestions: [],
      covidQuestions: [],
      message: false,
      description: false,
      flueVaccineMessage: false,
      preliminaryQuestionShowMessage: false,
      preliminaryQuestionMessage: [],
      customField: {},
      slots: [],
      slot: [],
      step: 1,
      steps: [],
      date: "",
      dateFormatted: null,
      preAssessmentId: "",
      showDate: true,
      location: "",
      eventLocation: "",
      showLocation: true,
      dates: [],
      locations: [],
      column: null,
      room: null,
      firstname: null,
      lastname: null,
      email: null,
      confirmEmail: null,
      communcations: true,
      mobile: null,
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      termsAgree: null,
      menu: false,
      formHasErrors: false,
      days: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ],
      months: [
        { text: "January", value: "01" },
        { text: "February", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" }
      ],
      requiredRules: [v => !!v || "Item is required"],
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      confirmEmailRules: [
        v => !!v || "Confirmation email is required",
        v => v === this.email || "Confirmation email must match email"
      ],
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+/.test(v) || "E-mail must be valid"
      }
    };
  },
  validations: {
    firstname: { required },
    lastname: { required },
    email: { required, email },
    confirmEmail: { required, email, sameAsEmail: sameAs("email") },
    mobile: { required },
    dobDay: { required },
    dobMonth: { required },
    dobYear: { required },
    termsAgree: { required }
  },
  async created() {
    const that = this;
    const event = this.eventData;
    this.event = event[0];

    const logo = this.event.eventCompany.logo;
    if (logo) {
      var s3 = new s3helper();
      s3.gets3Image(logo).then(s3Url => {
        this.logo = s3Url;
      });
    }

    if (this.event.message) {
      this.message = this.event.message;
    }
    if (this.event.description) {
      this.description = this.event.description;
    }

    // Filter out any event locations without slot groups
    const locations = this.event.eventLocation.items.filter(location => {
      return location.eventSlotGroup.items.length > 0;
    });

    // Custom fields
    this.collectUserDatas = Booking.customFields(this.event);

    // Flu Vaccine
    this.fluVaccineQuestions = PreQuestions.fluQuestions;

    // Covid Questions
    this.covidQuestions = PreQuestions.covidQuestions;

    // Booking steps
    this.steps = Booking.bookingSteps(
      this.collectUserDatas,
      this.event.preQuestionTemplate
    );

    // If only 1 location
    if (locations.length === 1) {
      this.location = locations[0].id;
      this.showLocation = false;
      const eventSlotGroup = locations[0].eventSlotGroup.items;
      this.selectLocation(this.location);
      if (eventSlotGroup.length === 1) {
        // If only 1 event group
        this.date = locations[0].eventSlotGroup.items[0].id;
        this.room = locations[0].eventSlotGroup.items[0].room;
        this.selectDate(this.date);
        this.showDate = false;
      }
    } else {
      that.locations = locations.map(location => {
        return {
          value: location.id,
          text: location.addressLine1 + " (" + location.town + ")"
        };
      });
      that.locations = _.orderBy(that.locations, "text", "asc");
    }

    // Subscribe to bookings
    const eventSlot = await API.graphql({
      query: onUpdateEventSlot,
      variables: null,
      authMode: "API_KEY"
    });

    eventSlot.subscribe({
      next: eventslot => {
        this.slots.forEach(function(slot) {
          if (eventslot.value.data.onUpdateEventSlot.id) {
            if (slot.id === eventslot.value.data.onUpdateEventSlot.id) {
              slot.booked = 1;
            }
          }
        });
      }
    });
  },
  methods: {
    async createPreAssessment() {
      const that = this;
      const $ = JQuery;

      const params = {
        firstName: this.firstname,
        lastName: this.lastname,
        dob: this.dobDay + "/" + this.dobMonth + "/" + this.dobYear, // "30/06/1976",
        phoneNumber: this.mobile,
        companyName: this.event.eventCompany.name,
        companyCode: this.$route.params.eventcode.toLowerCase(),
        email: this.email,
        assessmentDate: moment(this.slot[0].date).format("DD/MM/YYYY"),
        assessmentTime: this.slot[0].slot.substring(0, 5),
        assessmentRoom: this.room,
        region: null,
        location: null,
        department: null,
        gender: null,
        employeeno: this.customField["employeeNumber"]
          ? this.customField["employeeNumber"]
          : ""
      };

      await $.ajax({
        headers: {
          Accept: "application/json"
        },
        data: JSON.stringify(params),
        type: "POST",
        url: "https://preassessment.healthyevents.co.uk/subject/create/ajax",
        success: function(data) {
          that.preAssessmentId = data.hash;
        }
      });
    },
    async sendPreAssessmentLink() {
      const result = await PreAssessment.sendPreAssessmentEmail({
        email: this.email,
        firstName: this.firstname,
        preAssessmentLink: this.preAssessmentId
      });

      if (result.success === "Email sent successfully") {
        alert(
          "Thank you!  A link to your pre-assessment questionnaire has been sent to " +
            this.email
        );
      }
      return false;
    },
    selectDate(id) {
      var that = this;
      this.slots = [];
      const location = this.event.eventLocation.items.filter(
        location => location.id === this.location
      );
      if (location.length > 0) {
        if (location[0].eventSlotGroup.items) {
          const group = location[0].eventSlotGroup.items.filter(
            group => group.id === id
          );
          if (group[0].eventSlot.items) {
            var slots = [];
            this.room = group[0].room;
            this.eventLocation = `${location[0].addressLine1} ${location[0].town}`;
            const date = moment(group[0].date);
            const today = moment();
            const isToday = today.isSame(date, "d") ? true : false;
            this.dateFormatted = date.format("Do MMMM YYYY");
            group[0].eventSlot.items.forEach(function(slot) {
              if (slot.type === "SLOT") {
                // Has booking been made
                if (slot.eventBooking.items[0]) {
                  var booking = slot.eventBooking.items[0];
                }

                // If today and time passed set to booked
                if (isToday) {
                  const time = moment(slot.time.substring(8, 13), "HH:mm");
                  if (moment().diff(time, "minutes") > 0) {
                    booking = true;
                  }
                }

                slots.push({
                  id: slot.id,
                  length: slot.length,
                  time: slot.time,
                  type: slot.type,
                  booked: booking ? 1 : 0
                });
              }
            });
            let sorted = slots.sort(
              (a, b) =>
                new Date("1970/01/01 " + a.time.substring(0, 5)) -
                new Date("1970/01/01 " + b.time.substring(0, 5))
            );
            that.slots = sorted;
          }
        }
      }
    },
    selectLocation(id) {
      var that = this;
      this.dates = [];
      this.slots = [];
      this.room = null;
      const results = this.event.eventLocation.items.filter(
        item => item.id === id
      );

      results[0].eventSlotGroup.items.forEach(function(event) {
        var d = moment(event.date);
        that.dates.push({
          text: d.format("DD/MM/YYYY"),
          value: event.id
        });
      });
      that.dates.sort(
        (a, b) =>
          new Date(
            a.text.substring(6, 10) +
              "-" +
              a.text.substring(3, 5) +
              "-" +
              a.text.substring(0, 2)
          ) -
          new Date(
            b.text.substring(6, 10) +
              "-" +
              b.text.substring(3, 5) +
              "-" +
              b.text.substring(0, 2)
          )
      );
    },
    selectTimeSlot(id) {
      var that = this;
      this.slot = [];
      const location = this.event.eventLocation.items.filter(
        location => location.id === this.location
      );
      if (location[0].eventSlotGroup.items) {
        const group = location[0].eventSlotGroup.items.filter(
          group => group.id === this.date
        );
        if (group[0].eventSlot.items) {
          const slot = group[0].eventSlot.items.filter(slot => slot.id === id);
          if (slot[0]) {
            that.slot.push({
              id: slot[0].id,
              slot: slot[0].time,
              date: group[0].date
            });
            that.step = this.steps.slots.step + 1;
          }
        }
      }
    },
    save() {
      this.$refs.menu.save("2015-01-01");
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async submitPersonDetails() {
      const that = this;
      const customData = [];
      if (this.$refs.form.validate()) {
        this.submitPersonLoader = true;
        this.collectUserDatas.forEach(function(custom) {
          customData.push({
            label: custom.label,
            data: that.customField[custom.label]
          });
        });

        // isBooked
        const booking = await Booking.createBooking({
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          mobile: this.mobile,
          dob: this.dobDay + "/" + this.dobMonth + "/" + this.dobYear,
          customData: this.customField,
          isDeleted: 0,
          startTime: moment(
            this.slot[0].date + " " + this.slot[0].slot.substring(0, 5)
          ),
          eventBookingEventSlotId: this.slot[0].id
        });

        if (booking !== false) {
          // Send email
          await Booking.sendBookingEmail({
            slotTime: booking.eventSlot.time,
            eventDate: booking.eventSlotGroup.date,
            company: booking.eventCompany.name,
            event: booking.event.name,
            room: booking.eventSlotGroup.room,
            firstname: booking.firstname,
            lastname: booking.lastname,
            email: booking.email,
            phone: booking.mobile,
            iCalendar: booking.event.iCalendar,
            bloodDropStart: booking.event.bloodDropStart,
            bloodDropEnd: booking.event.bloodDropEnd,
            urinePotLocation: booking.event.urinePotLocation,
            commsLink: booking.event.commsLink,
            commsTemplateId: booking.event.commsTemplate,
          });

          // Send SMS
          Booking.sendTextMessage({
            slotTime: booking.eventSlot.time,
            mobile: booking.mobile,
            event: booking.event.name,
            eventDate: booking.eventSlotGroup.date,
            firstname: booking.firstname,
            lastname: booking.lastname,
            room: booking.eventSlotGroup.room,
            commsTemplateId: booking.event.commsTemplate
          });

          this.createPreAssessment();

          this.submitPersonLoader = false;
          this.step = this.steps.contactdetails.step + 1;
        } else {
          // Slot taken
          this.submitPersonLoader = false;
          this.dialogBookingTaken = true;
          this.step = this.steps.contactdetails.step - 1;
        }
      }
    },
    async submitFluVaccineQuestions() {
      const that = this;
      if (this.$refs.fluForm.validate()) {
        let valid = true;
        this.fluVaccineQuestions.questions.forEach(function(vaccine) {
          if (vaccine.success !== that.customField[vaccine.id]) {
            valid = false;
          }
        });
        if (valid) {
          this.flueVaccineMessage = false;
          this.step = this.steps.fluQuestions.step + 1;
        } else {
          this.flueVaccineMessage = true;
        }
      }
    },
    submitPreliminaryQuestions() {
      const that = this;
      if (this.$refs.preliminaryForm.validate()) {
        let valid = true;
        this.preliminaryQuestionMessage = [];
        this.collectUserDatas.forEach(function(data) {
          if (data.questionType === "PREQUESTION") {
            if (data.fieldType !== "checkbox") {
              if (data.success !== that.customField[data.fieldName]) {
                that.preliminaryQuestionMessage.push(data.error);
                valid = false;
              }
            } else {
              if (!that.customField[data.fieldName]) {
                that.preliminaryQuestionMessage.push(data.error);
                valid = false;
              }
            }
          }
        });
        if (valid) {
          this.preliminaryQuestionShowMessage = false;
          this.step = this.steps.premilinary.step + 1;
        } else {
          this.preliminaryQuestionShowMessage = true;
        }
      }
    },
    questionHandler(customField, step) {
      this.customField = customField;
      this.step = step;
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  computed: {
    firstnameErrors() {
      const errors = [];
      if (!this.$v.firstname.$dirty) return errors;
      !this.$v.firstname.required && errors.push("First name is required.");
      return errors;
    },
    lastnameErrors() {
      const errors = [];
      if (!this.$v.lastname.$dirty) return errors;
      !this.$v.lastname.required && errors.push("Last name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("Email is required");
      return errors;
    },
    confirmEmailErrors() {
      const errors = [];
      if (!this.$v.confirmEmail.$dirty) return errors;
      !this.$v.confirmEmail.email && errors.push("Must be valid e-mail");
      !this.$v.confirmEmail.required && errors.push("Email is required");
      !this.$v.confirmEmail.sameAsEmail &&
        errors.push("Emails must be identical");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      !this.$v.mobile.required && errors.push("Mobile is required.");
      return errors;
    },
    dobDayErrors() {
      const errors = [];
      if (!this.$v.dobDay.$dirty) return errors;
      !this.$v.dobDay.required && errors.push("Day is required.");
      return errors;
    },
    dobMonthErrors() {
      const errors = [];
      if (!this.$v.dobMonth.$dirty) return errors;
      !this.$v.dobMonth.required && errors.push("Month is required.");
      return errors;
    },
    dobYearErrors() {
      const errors = [];
      if (!this.$v.dobYear.$dirty) return errors;
      !this.$v.dobYear.required && errors.push("Year is required.");
      return errors;
    },
    termsAgreeErrors() {
      const errors = [];
      if (!this.$v.termsAgree.$dirty) return errors;
      !this.$v.termsAgree.required &&
        errors.push("You must agree to continue.");
      return errors;
    },
    internationalMobile() {
      let internationalMobile = this.mobile.replace(/^0+/, "");
      return "44" + internationalMobile;
    },
    rangeOfYears() {
      const currentYear = new Date().getFullYear();
      let range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );
      range = range(currentYear - 17, currentYear - 90, -1);
      return range;
    }
  }
};
</script>
<style>
.amplify-image {
  width: 100% !important;
}
html .person-form .hint.v-text-field--enclosed .v-text-field__details {
  display: flex !important;
}
html .person-form .hint.v-text-field--enclosed .v-text-field__details {
  display: flex !important;
}
</style>
